import { secureApi } from 'services/api';
import { Notification } from 'types/Notification';

export const notificationsApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    getInbox: builder.query<Notification[], void>({
      query: () => ({
        url: '/api/user/inbox',
        method: 'GET',
      }),
      providesTags: ['Inbox'],
    }),
    deleteInboxMessages: builder.mutation<void, string[]>({
      query: uuids => ({
        url: '/apiv2/user/inbox',
        method: 'DELETE',
        data: { uuids },
      }),
      async onQueryStarted(uuids, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData(
            'getInbox',
            undefined,
            draft => {
              return draft.filter(
                notification => !uuids.includes(notification.id),
              );
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    markInboxAsRead: builder.mutation<void, string[]>({
      query: uuids => ({
        url: '/apiv2/user/inbox/markAsRead',
        method: 'POST',
        data: { uuids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      async onQueryStarted(uuids, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData(
            'getInbox',
            undefined,
            draft => {
              draft.forEach(notification => {
                if (uuids.includes(notification.id)) {
                  notification.isRead = true;
                }
              });
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    markInboxAsUnread: builder.mutation<void, string[]>({
      query: uuids => ({
        url: '/apiv2/user/inbox/markAsUnread',
        method: 'POST',
        data: { uuids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      async onQueryStarted(uuids, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData(
            'getInbox',
            undefined,
            draft => {
              draft.forEach(notification => {
                if (uuids.includes(notification.id)) {
                  notification.isRead = false;
                }
              });
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
  overrideExisting: true,
});
